"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let getAccessTokenSilently = () => { };
const manageAuth0AccessToken = {
    getAccessTokenSilently: () => getAccessTokenSilently,
    setAccessTokenSilently: (func) => (getAccessTokenSilently = func),
};
exports.default = manageAuth0AccessToken;
